const toTitleCase = str =>
  // Regex: finds whole word or word followed by whitespace
  str.replace(/\w\S*/g, txt => `${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`)


const getHash = () => window.location.hash.substring(1)

const clearHash = () => {
  if (window.history.replaceState) {
    history.replaceState({}, document.title, '.')
  } else {
    window.location.hash = ''
  }
}

const getPathname = () => window.location.pathname

const addSpacesToPhoneNo = phoneNumber => (
  `${phoneNumber.substr(0, 5)}\xa0${phoneNumber.substr(5, 3)}\xa0${phoneNumber.substr(8)}`
)

export {
  toTitleCase,
  getHash,
  clearHash,
  getPathname,
  addSpacesToPhoneNo
}



// WEBPACK FOOTER //
// ./src/utils/common.js